import {t} from "../../i18n";
import DisplayParams from "../DisplayParams";
import {ReactSVG} from "react-svg";
import {useContext} from "react";
import {escape} from "lodash";
import EventLogo from "./EventLogo";

export default function EventName({invertLogo}: {invertLogo?: boolean}) {
    const displayParams = useContext(DisplayParams)

    const sponsorAttr = invertLogo ? "eventInverseSponsor" : "eventSponsor";
    const formattedEventName = escape(displayParams.eventName).replaceAll(/\bFIRST\b/g, "<i>FIRST</i>")
    return <>
        <EventLogo logo={displayParams.eventLogo} /> <span dangerouslySetInnerHTML={{__html: formattedEventName}} /> {displayParams[sponsorAttr] ? <><span className={"sponsorIntro"}>{t`Sponsored By`}</span><img className="sponsorLogo" src={displayParams[sponsorAttr].logo} /></> : null}
    </>
}